"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlowNodeViewModel = void 0;
const BaseElementViewModel_1 = require("./BaseElementViewModel");
class FlowNodeViewModel extends BaseElementViewModel_1.BaseElementViewModel {
    constructor(flowNode, processModel) {
        super(flowNode, processModel);
        this.name = flowNode.name;
        this.flowNodeType = flowNode.bpmnType;
    }
}
exports.FlowNodeViewModel = FlowNodeViewModel;
//# sourceMappingURL=FlowNodeViewModel.js.map